import styled from 'src/style';
import { mediaQueries } from 'src/style/breakpoints';
import colors from 'src/style/colors';
import { Paragraph } from 'src/components/Typography/index';

// FORM SECTION

export const SubtitleForm = styled.p({
  fontSize: 21,
  lineHeight: '24px',
  fontWeight: 500,
  color: colors.purpleDark,
  paddingTop: 4,
  paddingBottom: 10,
  [mediaQueries.phoneOnly]: {
    fontSize: 19,
    lineHeight: '20px',
    textAlign: 'center',
  },
});

// PROGRAM SECTION

export const ProgramSubtitle = styled.h2({
  fontSize: 23,
  lineHeight: '30px',
  color: colors.purpleDark,
  paddingTop: 0,
  paddingBottom: 5,
  [mediaQueries.phoneOnly]: {
    fontSize: 19,
    lineHeight: '25px',
    textAlign: 'center',
  },
});

export const ProgramText = styled.p({
  fontSize: 19,
  color: colors.purpleDark,
  lineHeight: '28px',
  paddingTop: 5,
  paddingBottom: 20,
  [mediaQueries.phoneOnly]: {
    fontSize: 16,
    lineHeight: '25px',
    textAlign: 'center',
  },
});

export const ModuleTitle = styled.p({
  fontSize: 17,
  lineHeight: '18px',
  fontWeight: 'bold',
  color: colors.purpleDark,
  paddingBottom: '0px',
  [mediaQueries.phoneOnly]: {
    fontSize: 18,
    lineHeight: '24px',
    paddingBottom: '0px',
  },
});

export const ModuleSubtitle = styled.p({
  fontSize: 17,
  lineHeight: '18px',
  paddingTop: '5px',
  paddingBottom: '0px',
  color: colors.purpleDark,
  [mediaQueries.phoneOnly]: {
    fontSize: 18,
    lineHeight: '24px',
    paddingBottom: '0px',
  },
});

export const ModuleDescription = styled.p({
  fontSize: 16,
  lineHeight: '25px',
  marginTop: 10,
  marginBottom: 10,
  color: colors.purpleDark,
  [mediaQueries.phoneOnly]: {
    fontSize: 18,
    lineHeight: '24px',
    paddingBottom: '0px',
  },
});

export const SkillDescription = styled.p({
  fontSize: 16,
  lineHeight: '28px',
  color: '#9d9d9d',
  paddingTop: 0,
  paddingBottom: 0,
  textAlign: 'justify',
  [mediaQueries.phoneOnly]: {
    fontSize: 16,
  },
});

// ALTERNANCE BREAKDOWN SECTION

export const LineDescriptionStart = styled.div({
  color: colors.yellow,
  width: 'fit-content',
  letterSpacing: 1,
  paddingLeft: '20px',
  [mediaQueries.tabletLandscapeUp]: {
    transform: 'rotate(-25deg)',
    marginBottom: '50px',
    marginLeft: '-8px',
    paddingLeft: '0px',
  },
});

export const LineDescriptionEnd = styled.div({
  color: colors.yellow,
  letterSpacing: 1,
  paddingLeft: '20px',
  [mediaQueries.tabletLandscapeUp]: {
    transform: 'rotate(-25deg)',
    marginTop: '5px',
    marginLeft: '-19px',
    paddingLeft: '0px',
  },
});

export const BreakdownSection = styled.div({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  textAlign: 'left',
  letterSpacing: 0.5,
  margin: '30px 20px 50px 40px',
  [mediaQueries.tabletLandscapeUp]: {
    margin: '50px 0px 0px 0px',
  },
});

export const BreakdownSectionTitle = styled(Paragraph.withComponent('span'))({
  fontWeight: 'bold',
  fontSize: 19,
  lineHeight: '24px',
  padding: 0,
  [mediaQueries.tabletLandscapeUp]: {
    padding: '0 20px 20px 20px',
  },
});

export const BreakdownSectionText = styled(Paragraph)({
  fontSize: 16,
  lineHeight: '25px',
  paddingTop: 5,
  [mediaQueries.tabletLandscapeUp]: {
    padding: '20px 50px 20px 20px',
  },
  [mediaQueries.phoneOnly]: {
    fontSize: 16,
    lineHeight: '20px',
  },
});

export const ColoredBox = styled.div(
  {
    height: 15,
    width: 15,
  },
  ({ color }) => ({
    backgroundColor: colors[color],
  })
);
